module.exports = __webpack_public_path__ + "static/media/archive.2048fa7d.svg";